"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return OutlineSubdomain;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function OutlineSubdomain(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9998 3C8.31077 3 5.13795 5.21965 3.74823 8.40037L1.91553 7.59963C3.61204 3.71673 7.48754 1 11.9998 1C16.512 1 20.3876 3.71673 22.0841 7.59963L20.2514 8.40037C18.8616 5.21965 15.6888 3 11.9998 3ZM3.74823 15.5996C5.13795 18.7803 8.31077 21 11.9998 21C15.6888 21 18.8616 18.7803 20.2514 15.5996L22.0841 16.4004C20.3876 20.2833 16.512 23 11.9998 23C7.48754 23 3.61204 20.2833 1.91553 16.4004L3.74823 15.5996Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.0286 4.27526C9.34516 5.18725 8.75794 6.54238 8.39288 8.21343L6.43896 7.78657C6.84547 5.92581 7.52507 4.28094 8.42813 3.07588C9.32482 1.87934 10.5404 1 11.9999 1C13.4593 1 14.6749 1.87934 15.5716 3.07588C16.4747 4.28094 17.1543 5.92581 17.5608 7.78657L15.6069 8.21343C15.2418 6.54238 14.6546 5.18725 13.9712 4.27526C13.2813 3.35476 12.5907 3 11.9999 3C11.409 3 10.7184 3.35476 10.0286 4.27526ZM10.0286 19.7247C10.7184 20.6452 11.409 21 11.9999 21C12.5907 21 13.2813 20.6452 13.9712 19.7247C14.6546 18.8128 15.2418 17.4576 15.6069 15.7866L17.5608 16.2134C17.1543 18.0742 16.4747 19.7191 15.5716 20.9241C14.6749 22.1207 13.4593 23 11.9999 23C10.5404 23 9.32482 22.1207 8.42813 20.9241C7.52507 19.7191 6.84547 18.0742 6.43896 16.2134L8.39288 15.7866C8.75794 17.4576 9.34516 18.8128 10.0286 19.7247Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 8L11 2L13 2L13 8L11 8ZM11 22L11 16L13 16L13 22L11 22Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 7H24V17H0V7ZM2 9V15H22V9H2Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("rect", {
        x: "7",
        y: "11",
        width: "2",
        height: "2",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("rect", {
        x: "11",
        y: "11",
        width: "2",
        height: "2",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("rect", {
        x: "15",
        y: "11",
        width: "2",
        height: "2",
        fill: "white"
    }));
}

//# sourceMappingURL=OutlineSubdomain.js.map